module.exports = __webpack_public_path__ + "static/img/campusparty.8e63c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/campusparty.png
// module id = m9Ag
// module chunks = 0